/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import {BaseFieldEditor} from "./BaseFieldEditor";
import {ObjectUtils} from "../../../Utils/ObjectUtils";

export class JsonFieldEditor extends BaseFieldEditor {
    @autobind
    displayValue() {
        if (this.props.Value === null) {
            return "";
        }

        if (typeof this.props.Value === 'object') {
            return JSON.stringify(this.props.Value, undefined, 2);
        }

        return this.props.Value;
    }

    @autobind
    updateField(value) {
        if (ObjectUtils.IsJson(value)) {
            this.props.OnUpdate(JSON.parse(value));
        } else {
            this.props.OnUpdate((typeof value === 'string' && value.trim() === '') ? null : value);
        }
    }

    @autobind
    _render() {
        return <FormControl
            className="json-field-editor"
            as="textarea"
            value={this.displayValue()}
            onChange={(x) => this.updateField(x.target.value)}
            placeholder={this.props.FieldDef.placeholder}
        />;
    }
}
